import get from 'lodash.get';

const getUserData = (rootState) => get(rootState, 'user.userData', null);

export default getUserData;
